export function show (data,k) {

    for (let i = 0; i < data.length; i++) {
      if (k == data[i].permission) {
        return true
      }
      else {
        
      }
    }


}